import { rei } from "@/services/api"

class pedidoService {

    static storePedido (payload) {
        return rei.post('cx-pedido-store', payload)
          .then(res => res.data)
      }
    
      static indexPedido (payload) {
        return rei.get(`cx-pedido-index/${payload}`)
          .then(res => res.data)
      }

      static getPedidosDia (caixaId) {
        return rei.get(`cx-pedido-dia/${caixaId}`)
          .then(res => res.data)
      }
      
      static filterPedido (payload) {
        const searchParams = new URLSearchParams(payload)

        return rei.get(`cx-pedido-pendente-filtro?${searchParams.toString()}`)
          .then(res => res.data)
      }

      static getSaldo (payload) {
        return rei.get(`get-saldo-caixa/${payload}`)
          .then(res => res.data)
      }

      static getPdfRelatorio (data) {
        return rei.post(`gerar-pdf-fechamento`, data, { responseType: 'arraybuffer' }).then((res) => {
          let blob = new Blob([res.data], { type: 'application/pdf' })
          let url = window.URL.createObjectURL(blob)
    
          return url
        })
      }

      static uploadFiles (form, id) {
        return rei.post(`cx-files/${id}`, form)
        .then(res => res.data)
      }

      static deletePedido (idPedido) {
        return rei.post(`cx-pedido-delete/${idPedido}`)
          .then(res => res.data)
      }

      static excluirRecebimentosAvulsos (payload) {
        return rei.post('excluir-recebimentos-avulsos', payload)
          .then(res => res.data)
      }
}

export default pedidoService